import React, {useState} from 'react';
import style from './workexperience.module.css';
import animatedStyle from './animatedeffects.module.css';

import { Circle, HalfCircle, FilledCircle, FilledHalfCircle } from './Shapes';

const data = [
    {
        position:'Quant & Infrastructure Developer',
        company:'SCX Holdings',
        period:'May21',
        description:'At SCX I research and develop market models (alphas) '+
            'using statistical & machine learning techniques, ' +
            'and I build the trading infrastructure ' + 
            'that enables our crypto-based operations across ' +
            'multiple exchanges.',
        tools: ['python', 'flask', 'react', 'scikit-learn', 'numpy', 'pandas', 
            'plotly', 'scipy', 'sqlalchemy', 'postgresql', 'aws']
    },
    {
        position:'Software Developer',
        company:'Self Employed',
        period:'Jan20 May21',
        description:'Working as a contractor '+
            'for a handful of clients in trading-related projects ' + 
            'led me to build an open-source algo trading library ' +
            'for backtesting and trading (pyjuque). '+
            'I also developed an abitrage bot for descentralised exchanges '+
            'and a web-app that interfaces with the open-source library.',
        tools: ['python', 'flask', 'react', 'solidity', 'numpy', 'pandas', 
            'plotly', 'dash', 'sqlalchemy', 'postgresql', 'aws']
    
    }, {
        position:'Technical Founder',
        company:'Eazitrip.com',
        period:'Mar19 Mar20',
        description:'As the tech person in this 2-person start-up '+
            'I took EaziTrip from idea - '+
            'an enhanced way to visualize your surroundings and find ' + 
            'places of interest - to an iOS and Android app, putting '+
            'together multiple new technologies into an AR '+
            'product developed from scratch, in less than 6 months.'
    }, {
        position:'Frontend Developer',
        company:'NULS',
        period:'Feb19 Oct19',
        description:'Worked in React and Vue to develop the NULS mobile '+
            'wallet and helped with building some functionality for nulsjs, '+
            'an npm package used for interacting with the NULS blockchain.'
    }, {
        position:'Product Developer',
        company:'Gatcoin.io',
        period:'Dec17 May18',
        description:'Built the initial GATCOIN mobile app, with some help '+
            'from a more senior developer. React Native & Firebase.'
    }
] 


export default function WorkExperience() {

    const [selected, setSelected] = useState(0);

    return <div id="work" className={style.main}>
        <h2 style={{
            fontSize:100,
            color:'var(--primary-bg-color'}}> Work </h2>
        <div className={style.container}>
            <div className={style.left}>
                {data.map((item, index) => {
                    return (
                        <div className={style.workEpisodeContainer}>
                            <div className={style.workEpisode} 
                                style={selected===index?
                                    {backgroundColor:'var(--secondary-bg-color)'}:{}}
                                onMouseEnter={() => setSelected(index)}
                                onMouseLeave={() => setSelected(null)}>
                                <h3 className={style.workPosition}> 
                                    {item.position}
                                </h3>
                                <p className={style.workPlace}> 
                                    {item.company}
                                </p>
                            </div>
                            <div className={style.rightSm}
                                onMouseEnter={ () => { setSelected(selected) }}
                                onMouseLeave={ () => { setSelected(null) }}
                                style={selected===index?{flex:1}:{flex:0}}
                                >
                                    {
                                    selected===index &&
                                        <div className={style.rightContainer} 
                                            style={ selected !== null
                                                ? { display:'flex'} : {display:'none'}}>
                                            <h3 className={style.workPeriod}> 
                                                {data[selected].period} 
                                            </h3>
                                            <p className={style.workDescription}>
                                                {data[selected].description}
                                            </p>
                                        </div>
                                    }
                            </div>
                        </div>)
                    }
                )}
            </div>
            {/* <div style={{width:2, backgroundColor: 'var(--primary-bg-color)'}} /> */}
            <div className={style.rightLg}
                onMouseEnter={ () => { setSelected(selected) }}
                onMouseLeave={ () => { setSelected(null) }}
                style={selected!==null?{flex:1}:{flex:0}}
                >
                    {
                    selected!==null &&
                        <div className={style.rightContainer} 
                            style={ selected !== null
                                ? { display:'flex'} : {display:'none'}}>
                            <h3 className={style.workPeriod}> 
                                {data[selected].period} 
                            </h3>
                            <p className={style.workDescription}>
                                {data[selected].description}
                            </p>
                        </div>
                    }
            </div>
        </div>


      {/* Top Left Circle */}
      <FilledCircle 
          size={200}
          color={'var(--tertiary-color-b)'}
          style={{
              zIndex:2,
              top:-120, right: 95,
              transform: 'rotateX(-180deg)'}}/>
  

        <Circle 
            size={80}
            color={'var(--tertiary-color-b)'}
            style={{
                zIndex:-1,
                top:77, right: 300,
                transform: 'rotateX(-180deg)'}}/>

        <FilledCircle 
          size={280}
          color={'var(--secondary-bg-color)'}
          style={{
              zIndex:-1,
              top:'calc(50vh - 190px)', 
              left: 'calc(50vw - 80px)',
              transform: 'rotateX(-180deg)'}}/>
                
        <Circle 
            size={140}
            color={'var(--tertiary-color-b)'}
            style={{
                zIndex:-1,
                top:'calc(85vh - 100px)', 
                left: 'calc(50vw - 250px)',
                transform: 'rotateX(-180deg)'}}/>
    
        <FilledHalfCircle 
            size={250}
            color={'var(--primary-text-color)'}
            style={{
                bottom:0, 
                left: 'max(30px, calc(25vw - 125px))', 
                // transform: 'rotateX(-180deg)',
                zIndex:1}}/>  

    </div>;
}
